$(document).ready(function() {
  $('.luxury-watch-slider').slick({
    slidesToShow: 3.4,
    arrows: false,
    infinite: false,
    variableWidth: false,
    draggable: true,
    cssEase: 'ease',
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
